module.exports = __webpack_public_path__ + "static/media/drawerMenu.bca26e19.svg";